/**
 * AppLayout — Main application shell.
 *
 * Structure:
 *   Desktop: Sidebar (left) + TopBar (top) + Content (scrollable)
 *   Mobile:  TopBar (top) + Content (scrollable) + MobileTabBar (bottom)
 *
 * All glassmorphism. Light AND dark mode.
 * Sidebar collapses to icon-only. Mobile tab bar at <768px.
 */

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileTabBar } from './MobileTabBar';

export function AppLayout(): React.ReactElement {
  return (
    <div className="flex min-h-screen bg-surface-page dark:bg-dark-page">
      {/* Desktop sidebar — hidden on mobile */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-h-screen">
        <TopBar />

        {/* Page content — scrollable, padded, with mobile tab bar clearance */}
        <main className="flex-1 p-4 md:p-6 pb-24 md:pb-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom tab bar — visible on mobile only */}
      <MobileTabBar />
    </div>
  );
}
